import { emitOriginalSourceChanged } from "../../observable/useOnOriginalSourceChanged";
import { isLayer } from "../validator/useLayerIdentity";
import useQueryOriginalSourceByLayer from "../store/useStoreOriginalSource";
import { emitSourceChanges } from "./useUpdater";


const useUpdateOriginalSource = (propPath, layer, key, value) => {
    const originalSource = useQueryOriginalSourceByLayer(layer);

    if (!originalSource) return;
    if (false === (key in originalSource)) return;

    if (isLayer(value)) {
        value = useQueryOriginalSourceByLayer(value)
    }

    if (originalSource && value !== undefined) {
        originalSource[key] = value;
        emitSourceChanges(originalSource, key, value);
    }
}

export default useUpdateOriginalSource;